import { createContext, useContext } from 'react';

export const FilterFieldsContext = createContext(null);

export const useFiltersFieldsManagerContext = () =>
  useContext(FilterFieldsContext);

export const useFiltersFields = ({ name, depends }) => {
  const ctx = useContext(FilterFieldsContext);

  return {
    fields: ctx.getFilterFields({ name, depends }),
  };
};

export default FilterFieldsContext;
